export const ar = {
  shared: {
    brand: "OrderHub",
    linkHint: "إذا لم يعمل الزر أعلاه، انسخ والصق الرابط في متصفحك:",
  },
  resetPassword: {
    subject: "إعادة تعيين كلمة المرور — OrderHub",
    brand: "OrderHub",
    greeting: "مرحباً {{name}}،",
    body: "تلقينا طلباً لإعادة تعيين كلمة المرور لحساب OrderHub الخاص بك. انقر على الزر أدناه لاختيار كلمة مرور جديدة.",
    cta: "إعادة تعيين كلمة المرور",
    linkHint: "إذا لم يعمل الزر أعلاه، انسخ والصق الرابط في متصفحك:",
    footer: "هذا الرابط ينتهي خلال ساعة واحدة. إذا لم تطلب إعادة تعيين كلمة المرور، يمكنك تجاهل هذا البريد الإلكتروني بأمان — ستظل كلمة المرور الخاصة بك كما هي.",
  },
  verification: {
    subject: "التحقق من عنوان البريد الإلكتروني — OrderHub",
    heading: "الرجاء التحقق من عنوان بريدك الإلكتروني",
    body: "شكراً لتسجيلك في OrderHub! يرجى التحقق من عنوان بريدك الإلكتروني لفتح جميع الوظائف، بما في ذلك ربط متاجر Shopify وإنشاء شروط التشغيل.",
    cta: "التحقق من عنوان البريد الإلكتروني",
    footer: {
      withToken: "هذا الرابط ينتهي خلال 24 ساعة. إذا لم تقم بإنشاء حساب في OrderHub، يمكنك تجاهل هذا البريد الإلكتروني بأمان.",
      noToken: "إذا لم تقم بإنشاء حساب في OrderHub، يمكنك تجاهل هذا البريد الإلكتروني بأمان.",
    },
  },
  reactivation: {
    subject: "تمت إضافتك مرة أخرى إلى {{orgName}} على OrderHub",
    heading: "مرحباً بعودتك!",
    body: "قام {{inviterName}} بإضافتك مرة أخرى إلى {{orgName}} على OrderHub. تم إعادة تفعيل حسابك. يمكنك تسجيل الدخول باستخدام بيانات الاعتماد الحالية الخاصة بك.",
    cta: "تسجيل الدخول إلى OrderHub",
    footer: "إذا لم تكن تتوقع هذا، يمكنك تجاهل هذا البريد الإلكتروني بأمان.",
  },
  invitation: {
    subject: "دعاك {{inviterName}} للانضمام إلى {{orgName}} على OrderHub",
    heading: "لقد تمت دعوتك!",
    body: {
      p1: "دعاك {{inviterName}} للانضمام إلى {{orgName}} على OrderHub.",
      p2: "يساعد OrderHub الفرق في إدارة طلبات Shopify والطلبات المسودة والسلات المتروكة مع سير عمل متابعة منظم.",
    },
    cta: "قبول الدعوة",
    footer: "إذا لم تكن تتوقع هذه الدعوة، يمكنك تجاهل هذا البريد الإلكتروني بأمان.",
  },
};